<template>
    <div class="page-menu page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">菜单管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                            <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleMenu('add')">添加 <i class="el-icon-plus"></i></el-button>
                   <!-- <el-button type="primary" class="btn-bg-rm" @click="delmultiple()">批量删除</el-button>-->
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" :indent="20" style="width: 100%;text-align: center;" row-key="icode" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                            <el-table-column prop="name" label="名称" min-width="180">
                                <!--<template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
                                </template>-->
                            </el-table-column>
                           <!-- <el-table-column prop="icode" width="55" label="icode" align="center">
                            </el-table-column> -->
                            <!--<el-table-column prop="icon" align="center" label="图标" min-width="160">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="scope.row.icon" height="23" @click="dlg_preview.img_url = scope.row.icon;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>-->
                            <el-table-column prop="icon" align="center" label="图标" min-width="120">
                            </el-table-column>
                            <el-table-column prop="parentKey" align="center" label="所属父级" min-width="120">
								<template slot-scope="scope">
								    <span v-if="scope.row.parentKey==0">顶级</span>
									<span v-else>{{scope.row.parentKey}}</span>
								</template>
                            </el-table-column>
							<el-table-column prop="menuKey" align="center" label="菜单key" min-width="120">
								
							</el-table-column>
                            <el-table-column prop="webUrl" align="center" label="链接地址" min-width="180">
                            </el-table-column>
                            <el-table-column prop="orderIndex" align="center" label="排序" min-width="120">
                            </el-table-column>
                            <el-table-column prop="enable" align="center" label="是否启用" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.enable">{{scope.row.enable}}</span>
                                </template>
                            </el-table-column>
                           <!-- <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column> -->
                            <!--<el-table-column prop="update_time" align="center" sortable label="更新时间" min-width="180">-->
                            <!--</el-table-column>-->
                            <!--<el-table-column prop="c_time" align="center" sortable label="创建时间" min-width="180">-->
                            <!--</el-table-column>-->
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
									<div>
										<el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleMenu('edit',scope.row)">编辑菜单</el-button>
										<el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteMenu(scope.row.icode)">删除菜单</el-button>
									</div>
									<div class="" style="margin-top: 20px;">
										<el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handlePower('add',scope.row)">新增权限</el-button>
										<el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handlePower('edit',scope.row)">编辑权限</el-button>
									</div>
									
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
					<el-pagination
					         @size-change="handleSizeChange"
					         @current-change="handleCurrentChange"
					         :current-page="table_data.page_info.page"
					         :page-sizes="[10,30, 50,80,100]"
					         :page-size="table_data.page_info.pageSize"
					         layout="total, sizes, prev, pager, next"
					         :total="table_data.page_info.total">
					 </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export menu-dialog" :title="dlg_menu.title" :visible.sync="dlg_menu.visible" width="534px" @close="closeMenu" :close-on-click-modal="false">
            <el-form ref="formMenu" :model="dlg_menu.form" label-width="110px" :rules="dlg_menu.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="菜单名称：" :error="dlg_menu.error.name">
                    <el-input size="small" v-model="dlg_menu.form.name" placeholder='请输入菜单名称' clearable></el-input>
                </el-form-item>
                <el-form-item prop="icon" label="图标：">
                    <el-input size="small" v-model="dlg_menu.form.icon" placeholder='请输入图标类名' clearable></el-input>
                </el-form-item>
                <el-form-item  prop="parentKey" label="所属父级：">
					<!-- <treeselect v-model="dlg_menu.form.parentKey" :multiple="false" :show-count="true" :options="dlg_menu.init_data.parent_list" /> -->
					
					 <Treeselect size="small" :data="dlg_menu.init_data.parent_list" :defaultKey="dlg_menu.form.icode" clearable checkStrictly @getValue="setTreeMenu"></Treeselect>
					<!-- <el-input size="small" v-model="dlg_menu.form.menuKey" placeholder='请输入' clearable></el-input> -->
                    <!-- <el-select size="small" v-model="dlg_menu.form.parentKey" placeholder="请选择" >
                        <el-option
                                v-for="item in dlg_menu.init_data.parent_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select> -->
                </el-form-item>
				<el-form-item prop="menuKey" label="菜单key：" >
				    <el-input size="small" v-model="dlg_menu.form.menuKey" placeholder='请输入链接地址' clearable></el-input>
				</el-form-item>
                
                <el-form-item prop="orderIndex" label="排序：">
                <el-input size="small" type='number' v-model="dlg_menu.form.orderIndex" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <el-form-item prop="enable" label="是否启用：">
                    <el-radio-group v-model="dlg_menu.form.enable">
                        <el-radio v-for="(item, index) in dlg_menu.init_data.show_name_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
               <el-form-item prop="autoCreateOpen" label="是否能访问：">
                    <el-radio-group v-model="dlg_menu.form.autoCreateOpen">
                        <el-radio v-for="(item, index) in dlg_menu.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_menu.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitMenu()" :loading="dlg_menu.btn_loading">确认</el-button>
            </span>
        </el-dialog>
		<el-dialog class="dialog-export menu-dialog" :title="dlg_power.title" :visible.sync="dlg_power.visible" width="534px" @close="closePower" :close-on-click-modal="false">
		    
			<el-form ref="formPower" :model="dlg_power.form" label-width="120px" :rules="dlg_power.rules" @submit.native.prevent>
		        <el-form-item v-if="dlg_power.init_data.power_list.length >0" label="删除菜单权限：">
		             <el-radio-group v-model="dlg_power.delPoverId">
		                 <el-radio v-for="(item, index) in dlg_power.init_data.power_list" :key="index" :label="item.icode">{{item.name}}</el-radio>
		             </el-radio-group>
					 <el-button type="primary" class="btn-bg-rm" style="margin-left: 30px;" @click="delPower()">删除权限</el-button>
		         </el-form-item>
				 <el-form-item v-if="dlg_power.title=='编辑权限'" prop="powerKey" label="选择权限：">
				     <el-select size="small" v-model="dlg_power.form.powerKey" placeholder="请选择" @change="(val) => checkChange(val)" >
				         <el-option
				                 v-for="item in dlg_power.init_data.power_list"
				                 :key="item.powerKey"
				                 :label="item.name"
				                 :value="item.powerKey">
				         </el-option>
				     </el-select>
				 </el-form-item>
				 <el-form-item v-else  prop="powerKey" label="powerKey：" >
				     <el-input size="small" v-model="dlg_power.form.powerKey" placeholder='请输入powerKey' clearable></el-input>
				 </el-form-item>
				<el-form-item prop="name" style="margin-top: 15px;" label="权限名称：" :error="dlg_power.error.name">
		            <el-input size="small" v-model="dlg_power.form.name" placeholder='请输入权限名称'  clearable></el-input>
		        </el-form-item>
				
				<el-form-item  prop="menuKey" label="menuKey：" >
				    <el-input size="small" v-model="dlg_power.form.menuKey" placeholder='请输入menuKey' disabled clearable></el-input>
				</el-form-item>
		        <el-form-item prop="webUrl" label="路由地址：" :error="dlg_power.error.url">
		            <el-input size="small" v-model="dlg_power.form.webUrl" placeholder='请输入路由地址' clearable></el-input>
		        </el-form-item>
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dlg_power.visible = false">取 消</el-button>
				
		        <el-button type="primary" @click="submitPower()" :loading="dlg_power.btn_loading">确定更改权限</el-button>
		    </span>
		</el-dialog>
    </div>
</template>
<script>
    import bus from '@/assets/js/defined.js'
	 // import the component
	  import Treeselect from '@/components/selectTree/selectTree.vue'
	
    export default {
        name: 'usercenter',
		components: { Treeselect },
        data() {
            return {
				defaultProps: {
				          children: 'children',
				          label: 'name'
				        },
                clientHeight:'',
                body_loading:false,
                is_refresh:true,
                /*init_data: {
                    status_list: [{id:-1, name: '全部'},{id:1, name: '开启'},{id:2, name: '禁用'}],
                },*/
                table_data:{
                    loading: false,
                    list:[],
					page_info: {
					    page: 1,
					    pageSize: 30,
					    total: 130
					}
                },
                menu_list:[],
                dlg_menu:{
					defaltXuan:[],
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    form:{
                        name:'',
                        parentKey:0,
                        icon:'',
                        
                        orderIndex:'',
                        enable:1,
                        status:1,
						menuKey:'',
						icode:'',
						autoCreateOpen:1
                    },
                    error:{
                        name:'',
                        url:''
                    },
                    reset_form: {},
                    init_data:{
                        parent_list:[],
                        status_list: [{id:0, name: '关闭'},{id:1, name: '开启'}],
                        show_name_list:[{id:1, name: '开启'},{id:0, name: '关闭'}]
							
                    },
                    rules:{
                        name:{required: true, message: '请输入菜单名称', trigger: ['change','blur']},
                        // parentKey:{required: true, message: '请选择所属父级', trigger: ['change','blur']},
                        enable:{required: true, message: '请选择是否显示', trigger: ['change','blur']},
                       // status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                        autoCreateOpen:{required: true, message: '请选择是否开启访问', trigger: ['change','blur']},
                        orderIndex:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']}
                    }
                },
				dlg_power:{
				    id:'',
				    visible:false,
				    btn_loading:false,
				    api: '',
				    title:'',
					delPoverId:0,
				    form:{
				        name:'',
				        parentKey:null,
				        icon:'',
				        webUrl:'',
				        orderIndex:'',
				        enable:1,
				        status:1,
						menuKey:'',
						icode:'',
				    },
				    error:{
				        name:'',
				        url:''
				    },
				    reset_form: {},
				    init_data:{
				        power_list:[],
				       
				    },
				    rules:{
				         name:{required: true, message: '请输入权限名称', trigger: ['change','blur']},
				        powerKey:{required: true, message: '请输入powerKey', trigger: ['change','blur']},
						
				       // powerKey::{required: true, message: '请选择所属父级', trigger: ['change','blur']},
				    }
				},
            }
        },
        created() {
            document.title = '菜单管理';
            this.dlg_menu.reset_form = Object.assign({}, this.dlg_menu.form);
			 this.dlg_power.reset_form = Object.assign({}, this.dlg_power.form);
            this.getList();
			//this.getListTree()
        },
        methods: {
			 setTreeMenu(key,data){//获取子组件值
			                console.log(key,"key")
			                console.log(data,"data菜单")
							this.dlg_menu.form.parentKey=data.menuKey
							
					
			            },
			getListTree() {
			    var _this = this;
			 
			    // var menu_top_list = [{icode:-9, name: '顶级',children:[{icode:-9,name:'顶级'}]}];
			    this.$client.get('/api/sys/menu/getTreeWithPowerSimpleForAdmin', {}, function(res,message){
					
			       // console.log(res,"树结构")
			        // _this.dlg_menu.init_data.parent_list = menu_top_list.concat(res)
					// _this.dlg_menu.init_data.parent_list =res
			         console.log( _this.dlg_menu.init_data.parent_list,"树结构")
			    },function(res){
			        
			    });
			},
            getList() {
                var _this = this;
               /* var params = _this.form_search;*/
                _this.table_data.loading = true;
                var menu_top_list = [{id:0, name: '顶级'}];
                this.$client.get('/api/sys/menu/getTreeForAdmin', {}, function(res,message,total,totalPages){
					
                    _this.table_data.list = res;
					_this.dlg_menu.init_data.parent_list =res
                   // _this.dlg_menu.init_data.status_list = res.status_name_list;
                    //_this.dlg_menu.init_data.show_name_list = res.show_name_list;
                    //_this.dlg_menu.init_data.parent_list = menu_top_list.concat(res.menu_top_list)
					//_this.table_data.page_info.page = totalPages;
					_this.table_data.page_info.total=total
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            getMenu(){
                var _this = this;
                this.$client.get('/api/sys/menu/getTreeToPCForCurrentUser', {}, function(res,message){
                    // localStorage.setItem('menu_auth_list',JSON.stringify(res.menu_auth_list));
                    // localStorage.setItem('menu_list',JSON.stringify(res.menu_list));
					var menuList=[]
										var menuItem={}
										var menu_auth_list=[]
										if(res){
											 menuList=[]
											 menu_auth_list=[]
											res.forEach((item)=>{
												menuItem={
														id:0,
														name:'',
														icon:'',
														p_id:0,
														url:'',
														power:[],
														sort:0,
														menuKey:'',
														status:0,
														enable:0,
														autoCreateOpen:null,
														children:[],
													}
												// console.log(item,"上res进入里面")
												menuItem.id=item.icode,
												menuItem.name=item.name,
												menuItem.icon=item.icon,
												menuItem.p_id=item.parentKey,
												menuItem.url=item.webUrl,
												menuItem.power=item.power,
												menuItem.sort=item.orderIndex,
												menuItem.menuKey=item.menuKey,
												menuItem.status=1,
												menuItem.enable=item.enable,
												menuItem.autoCreateOpen=item.autoCreateOpen
												
												if(item.children.length >0){
													
													item.children.forEach((itemc,indexc)=>{
														var menuItemc={
																id:0,
																name:'',
																icon:'',
																p_id:1,
																url:'',
																power:[],
																sort:0,
																menuKey:'',
																status:0,
																enable:0,
																autoCreateOpen:null,
																children:[],
															}
														menuItemc.id=itemc.icode,
														menuItemc.name=itemc.name,
														menuItemc.icon=itemc.icon,
														menuItemc.p_id=itemc.parentKey,
														menuItemc.url=itemc.webUrl,
														menuItemc.power=itemc.power,
														menuItemc.sort=itemc.orderIndex,
														menuItemc.menuKey=itemc.menuKey,
														menuItemc.enable=itemc.enable,
														menuItemc.autoCreateOpen=itemc.autoCreateOpen,
														menuItemc.status=1
														menuItem.children.push(menuItemc)
														// menu_auth_list.push({
														// 	itemc.parentKey+':'itemc.menuKey+':true'
														// })
													})
												}
												//console.log(menuItem,"每一个菜单")
												menuList.push(menuItem)
												if(index==1){
													menuList.push({
														id:2,
														name:'管理',
														icon:'center-icon',
														p_id:0,
														url:'',
														power:[],
														sort:98,
														menuKey:'',
														status:1,
														enable:1,
														autoCreateOpen:null,
														children:[
															{
																id:3,
																name:'菜单管理',
																icon:'icon-order2',
																p_id:1,
																url:'/system/menu',
																power:[],
																sort:33,
																menuKey:'',
																status:1,
																enable:1,
																autoCreateOpen:null,
																children:[],
															}
														],
														
													})
												}
												
												console.log(menuList,"整体菜单")
												
											})
											//console.log(menuList,menuItem,"菜单")
											
										}
										
									    setTimeout(function(){
											console.log(menuList,"菜单")
									         //localStorage.setItem('menu_auth_list',JSON.stringify(res.menu_auth_list?res.menu_auth_list:''));
									        // localStorage.setItem('menu_list',JSON.stringify(res.menu_list?res.menu_list:[]));
											localStorage.setItem('menu_auth_list',JSON.stringify(''));
											localStorage.setItem('menu_list',JSON.stringify(menuList));
											console.log(localStorage.getItem('menu_auth_list'),"获取菜单")
									    },300);
                    _this.menu_list = menuList;
                },function(res){

                });
            },
            handleMenu(type,data){
                this.dlg_menu.visible = true;
                if(type == 'add'){
                    this.dlg_menu.title = '添加菜单';
                    this.dlg_menu.api = '/api/sys/menu/save';
                }else{
                    this.dlg_menu.id= data.icode;
                    this.dlg_menu.title = '编辑菜单';
                    for(var key in this.dlg_menu.form){
                        this.dlg_menu.form[key] = data[key];
						// this.dlg_menu.defaltXuan.push(this.dlg_menu.form)
						// if(key=='id'){
						// 	this.dlg_menu.form.id=data.icode
						// }
                    }
					
                    this.dlg_menu.api = '/api/sys/menu/save';
                }
            },
			//获取权限
			getPower(menuKey){
				var _this = this;
				
				 _this.$client.get('/api/sys/menu_power/getListByMenuKey', {menuKey:menuKey}, function(res,message){
					 console.log(res,"获取权限")				
				     // _this.table_data.list = res;
				     _this.dlg_power.init_data.power_list = res
					 console.log(_this.dlg_power.init_data.power_list,"获取权限")
				     //_this.dlg_menu.init_data.show_name_list = res.show_name_list;
				     //_this.dlg_menu.init_data.parent_list = menu_top_list.concat(res.menu_top_list)
				    
				 },function(res){
				    
				 });
			},
			// //新增权限
			// addPower(type,data){
			// 	var _this=this;
			// 	var params={
					
			// 	}
			// 	_this.$client.get('/api/sys/menu_power/save', {params}, function(res,message){
			// 						 console.log(res,"获取权限")		
			// 		_this.getPower()
			// 	},function(res){
				   
			// 	});
				
			// },
			//删除权限
			delPower(){
				var _this=this;
				
				_this.$client.post('/api/sys/menu_power/delete', {id:_this.dlg_power.delPoverId}, function(res,message){
					console.log(res,"获取权限")		
					_this.getPower()
				},function(res){
				   
				});
				
			},
			 
			                
			// 编辑权限
			handlePower(type,data){
				console.log(data,"权限")
				this.getPower(data.menuKey)
                this.dlg_power.visible = true;        
                if(type == 'add'){
					this.dlg_power.title = '添加权限';
					
					this.dlg_power.api = '/api/sys/menu_power/save';
					for(var key in this.dlg_power.form){
						
													
						if(key !='icode'){
								this.dlg_power.form[key] = data[key];
						}
						if(key !='name'){
							this.dlg_power.form.name=""
						}
						
					}
				}else{
					this.dlg_power.id= data.icode;
					this.dlg_power.title = '编辑权限';
					for(var key in this.dlg_power.form){
						this.dlg_power.form[key] = data[key];
						if(key !='name'){
							this.dlg_power.form.name=""
						}
						if(key =='icode'){
							this.dlg_power.form.icode
						}
					}
					
					
					this.dlg_power.api = '/api/sys/menu_power/save';
				}
            },
            deleteMenu(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/api/sys/menu/delete', {id:id}, function(res,message){
                    _this.getList();
                    _this.$nextTick(()=>{
                        _this.getMenu();
                })
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitMenu(){
                var _this = this;
                _this.$refs['formMenu'].validate((valid) => {
                    if (valid) {
                        this.dlg_menu.btn_loading = true;
                        this.$client.post(this.dlg_menu.api, this.dlg_menu.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.$nextTick(()=>{
                                _this.getMenu();
								_this.getListTree()
                        })
                            _this.dlg_menu.btn_loading = false;
                            _this.dlg_menu.visible = false;
                        }, function(message){
                            _this.dlg_menu.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_menu.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
			//提交权限
			submitPower(){
				var _this = this;
				    _this.$refs['formPower'].validate((valid) => {
				        if (valid) {
				            this.dlg_power.btn_loading = true;
				            this.$client.post(this.dlg_power.api, this.dlg_power.form, function(res,message){
				                //console.log(res)
				                _this.$message(message);
				                _this.getList();
				                _this.$nextTick(()=>{
				                    _this.getMenu();
				            })
				                _this.dlg_power.btn_loading = false;
				                _this.dlg_power.visible = false;
				            }, function(message){
				                _this.dlg_power.btn_loading = false;
				                if((typeof message)==='object'){
				                    for(var key in message){
				                        _this.dlg_power.error[key] = message[key];
				                    }
				                }
				            });
				        } else {
				            console.log('error submit!!');
				    return false;
				}
				});
			},
			// 关闭菜单弹窗
            closeMenu(){
                for(var key in this.dlg_menu.form){
                    this.dlg_menu.form[key] = this.dlg_menu.reset_form[key];
                }
                this.$nextTick(()=>{
                this.$refs.formMenu.clearValidate();
            })
            },
			//选中得权限
			checkChange(val){
				console.log(val);//选中的值
				console.log("fashi")
				this.dlg_power.init_data.power_list.forEach((item)=>{
					if(item.powerKey==val){
						this.dlg_power.form.name=item.name,
						this.dlg_power.form.icode=item.icode,
						this.dlg_power.form.webUrl=item.webUrl
						
						
					}
				})
										
									
			   // console.log(row);//自定义的参数
			},
			// 关闭权限弹窗
			closePower(){
				for(var key in this.dlg_menu.form){
				        this.dlg_power.form[key] = this.dlg_power.reset_form[key];
				    }
				    this.$nextTick(()=>{
				    this.$refs.formPower.clearValidate();
				})
			},
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-227)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
            menu_list(new_list){
                bus.$emit('menuChange',new_list)
            },
			
        }
    }
</script>
<style>
    .el-drawer__header{
        margin-bottom: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #e9e9e9;
    }
    .el-drawer,.el-drawer__header,.el-drawer__header>:first-child{
        outline: none !important;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
    .page-menu .el-upload--picture-card{
        line-height: 80px;
    }
    .page-menu .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }

    .domain-dialog .el-form-item__label:before,.forward-dialog .el-form-item__label:before{
        display: none;
    }
    .approve-dialog .el-dialog__footer{
        text-align: center;
    }
    .error-dialog .el-dialog__header{
        border-bottom: none;
        padding-top: 25px;
        text-align: center;
    }
</style>
<style scoped>
    .tips{
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #ff5555;
    }
</style>